<template>
	<div :style="{ width: widthPercent + '%' }" class="cricleplay" @click="play">
		<div v-if="position == 'left'" style="display: flex">
			<div>
				<div class="small"></div>
				<div class="middle" :class="{ 'middle-animation': animate }"></div>
				<div class="large" :class="{ 'large-animation': animate }"></div>
			</div>
			<div class="duration">{{ duration }}</div>
		</div>
		<div v-if="position == 'right'" style="display: flex">
			<div class="duration">{{ duration }}</div>
			<div>
				<div class="right-large" :class="{ 'large-animation': animate }"></div>
				<div class="right-middle" :class="{ 'middle-animation': animate }"></div>
				<div class="right-small"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'audio-play',
	props: {
		time: null,
		url: null,
		position: {
			type: String,
			default: 'right',
		},
	},
	data() {
		return {
			audio: null,
			animate: false,
			timer: null,
			duration: null, //时间
		};
	},
	computed: {
		widthPercent() {
			// 语音小于10秒 都返回最小长度15%
			return 100;
		},
	},
	mounted() {
		this.audio = new Audio();
		this.audio.src = this.url;

		this.audio.addEventListener('canplaythrough', () => {
			this.duration = this.format(this.audio.duration);
		});
		this.audio.onplay = () => {
			this.animate = true;
			this.timer = setInterval(() => {
				this.animate = false;
				setTimeout(() => {
					this.animate = true;
				}, 50);
			}, 1250);
		};
		this.audio.onpause = () => {
			this.animate = false;
			this.timer && clearInterval(this.timer);
		};
		this.audio.onended = () => {
			this.animate = false;
			this.timer && clearInterval(this.timer);
		};
		// window.audioList.push(this.audio); //所有实例加入全局变量
	},
	methods: {
		play() {
			// window.audioList.forEach(audio => {
			//开始前先关闭所有可能正在运行的实例
			this.audio.pause();
			// });
			if (this.audio.paused) {
				this.animate = true;
				this.audio.play();
			} else {
				this.animate = false;
				this.audio.pause();
			}
		},
		format(s) {
			var t = '';
			if (s > -1) {
				var min = Math.floor(s / 60) % 60;
				var sec = s % 60;
				if (min) {
					t += '0';
					t += min + "'";
				}

				// if (sec < 10) {
				// 	t += '0';
				// }
				t += Math.floor(sec);
			}
			t = t + '"';
			return t;
		},
	},
};
</script>

<style lang="scss" scoped>
.cricleplay {
	display: flex;
	border: 1px solid #e8e8e8;
	border-radius: 6px;
	margin-top: 10px;
	padding: 5px;
	justify-content: center;
	align-items: center;
}
.duration {
	margin: 0px 20px;
	text-align: center;
	line-height: 32px;
}
.small {
	width: 23px;
	height: 10px;
	border-style: solid;
	border-top-color: transparent;
	border-left-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
}
.right-small {
	width: 23px;
	height: 10px;
	border-style: solid;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
	margin-left: -20px;
}
.middle {
	width: 38px;
	height: 25px;
	border-style: solid;
	border-top-color: transparent;
	border-left-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
	margin-left: -30px;
	// animation: show2 3s ease-in-out infinite;
	opacity: 1;
}
.right-middle {
	width: 30px;
	height: 25px;
	border-style: solid;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
	margin-left: -40px;
	// animation: show2 3s ease-in-out infinite;
	opacity: 1;
}
.middle-animation {
	animation: show2 3s ease-in-out infinite;
}
@keyframes show2 {
	0% {
		opacity: 0;
	}
	30% {
		opacity: 0.5;
	}
	100% {
		opacity: 0;
	}
}
.right-large {
	width: 48px;
	height: 35px;
	border-style: solid;
	border-top-color: transparent;
	border-right-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
	// margin-left: 20px;
	// animation: show3 3s ease-in-out infinite;
	opacity: 1;
}
.large {
	width: 48px;
	height: 35px;
	border-style: solid;
	border-top-color: transparent;
	border-left-color: transparent;
	border-bottom-color: transparent;
	border-radius: 50%;
	box-sizing: border-box;
	vertical-align: middle;
	display: inline-block;
	margin-left: -40px;
	// animation: show3 3s ease-in-out infinite;
	opacity: 1;
}
.large-animation {
	animation: show3 3s ease-in-out infinite;
}
@keyframes show3 {
	0% {
		opacity: 0;
	}
	60% {
		opacity: 0.5;
	}
	100% {
		opacity: 0;
	}
}
</style>
